/**
 * Converts a full locale (e.g., 'fr-FR') to short form for URLs (e.g., 'fr')
 */
export function getShortLocale(locale: string): string {
  return locale.split('-')[0] ?? locale
}

/**
 * Converts a full locale to Open Graph format (e.g., 'fr-FR' -> 'fr_FR')
 */
export function toOgLocale(locale: string): string {
  return locale.replace('-', '_')
}

/**
 * Builds the full URL for a given path and locale
 */
export function buildFullUrl(
  domain: string,
  path: string,
  locale: string | undefined,
  defaultLocale: string
): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (!locale || locale === defaultLocale) {
    return `${domain}${normalizedPath}`
  }

  const finalPath = normalizedPath === '/' ? '' : normalizedPath
  const shortLocale = getShortLocale(locale)
  return `${domain}/${shortLocale}${finalPath}`
}

/**
 * Extracts the path without locale prefix from a canonical URL
 */
export function extractBasePath(
  canonicalUrl: string,
  locales: string[]
): string {
  let path = canonicalUrl
  if (canonicalUrl.startsWith('https://')) {
    try {
      const url = new URL(canonicalUrl)
      path = url.pathname
    } catch {
      path = canonicalUrl
    }
  }

  const parts = path.split('/').filter(Boolean)
  if (parts.length > 0) {
    const firstPart = parts[0]
    const shortLocales = locales.map((l) => l.split('-')[0])
    if (shortLocales.includes(firstPart)) {
      return `/${parts.slice(1).join('/')}`
    }
  }

  return path.startsWith('/') ? path : `/${path}`
}
